<div class="modal1Main verifyPop">
  <div class="modalHeader">
    <span class="title">Verify Phone Number</span>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <form [formGroup]="sendOTPForm" (ngSubmit)="onSendOTPSubmit()" class="otpForm" *ngIf="!otpSent">
    <flash-messages></flash-messages>
    <div class="row">
        <div class="rightInput">
          <mat-form-field class="form-control">
            <input matInput [readonly]="otpSent" formControlName="phone_number" (keypress)="keyPress($event)" placeholder="Enter Phone number" class="text-center">
          </mat-form-field>
          <mat-error *ngIf="submitted && fSendOTP.phone_number.errors && fSendOTP.phone_number.errors.required">
            Email is required.
          </mat-error>
          <mat-error *ngIf="submitted && fSendOTP.phone_number.errors && (fSendOTP.phone_number.errors.minlength || fSendOTP.phone_number.errors.maxlength)">
            Invalid format (Expected format is xxx-xxx-xxxx).
          </mat-error>
        </div>
    </div>
    <div class="text-center popfoot">
      <button mat-raised-button color="primary">Send OTP</button>
    </div>
  </form>
  <form [formGroup]="verifyOTPForm" (ngSubmit)="onVerifyOTPSubmit()" class="otpForm" *ngIf="otpSent">
    <flash-messages></flash-messages>
    <div class="row">
      <div class="rightInput">
        <mat-form-field class="form-control">
          <input matInput [readonly]="otpSent" formControlName="phone_number" (keypress)="keyPress($event)" placeholder="Enter Phone number" class="text-center">
        </mat-form-field>
        <mat-error *ngIf="submitted && fVerifyOTP.phone_number.errors && fVerifyOTP.phone_number.errors.required">
          Email is required.
        </mat-error>
        <mat-error *ngIf="submitted && fVerifyOTP.phone_number.errors && (fVerifyOTP.phone_number.errors.minlength || fVerifyOTP.phone_number.errors.maxlength)">
          Invalid format (Expected format should be xxx-xxx-xxxx).
        </mat-error>
        <span class="editPhone" (click)="editPhoneNumber()"><i class="zmdi zmdi-edit"></i></span>
      </div>
    </div>
    <div class="row">
      <div class="rightInput">
        <mat-form-field class="form-control">
          <input matInput formControlName="otp" placeholder="Enter OTP">
        </mat-form-field>
        <mat-error *ngIf="submitted && fVerifyOTP.otp.errors && fVerifyOTP.otp.errors.required">
          OTP is required.
        </mat-error>
      </div>
    </div>
    <div class="text-right popfoot">
      <div class="leftButton">
        <button mat-raised-button color="primary">Verify OTP</button>
      </div>
      <div class="rightButton">
        <span class="otpResend"><a href="javascript:void(0)" (click)="onSendOTPSubmit()" *ngIf="otpSent && countDown < 1">Resend OTP</a></span>
         <span class="resendCounter" *ngIf="countDown > 0"> Didn't get OTP? Resend in {{this.countDown}} seconds</span>
      </div>
    </div>
  </form>
</div>